import { render, staticRenderFns } from "./choosePlatform.vue?vue&type=template&id=0bcbf5f6&scoped=true&"
import script from "./choosePlatform.vue?vue&type=script&lang=js&"
export * from "./choosePlatform.vue?vue&type=script&lang=js&"
import style0 from "./choosePlatform.vue?vue&type=style&index=0&id=0bcbf5f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcbf5f6",
  null
  
)

export default component.exports